import { useStatusesReturnType } from '@shared';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { ApiAudit, auditApi } from 'App';

export function useActionAudit(
  auditUuid: string,
  refetchStatuses: useStatusesReturnType['refetchStatuses']
) {
  const queryClient = useQueryClient();

  const handleSuccessfulMutation = (auditFinished: boolean) => {
    queryClient.setQueryData(
      ['statuses', auditUuid],
      (oldData: useStatusesReturnType['statuses']) => {
        if (oldData) {
          const newData = {
            ...oldData,
            auditFinished,
          };
          refetchStatuses(newData);
          return newData;
        } else {
          refetchStatuses();
        }
      }
    );
  };

  const { mutate: restartAudit } = useMutation({
    mutationFn: () => ApiAudit.restartAudit(auditUuid),
    onSuccess: () => handleSuccessfulMutation(false),
  });

  const { mutate: finishAudit } = useMutation({
    mutationFn: () => auditApi.finishAudit(auditUuid),
    onSuccess: () => handleSuccessfulMutation(true),
  });
  return { restartAudit, finishAudit };
}
